/*
Функция отправляет данные для входа на сервер и возвращает Promise с ответом с севера
*/

export default async function loginUser(credentials) {
  return fetch('/api/users/check/login', {
   method: 'POST',
   headers: {
     'Content-Type': 'application/json',
     'X-Requested-With': 'XMLHttpRequest',
     'Authorization': 'Bearer ' + credentials?.token
   },
 }).then(
    data => {
      if (data.ok) {
        return data.text().then(text => {return {ok: (text === "\"ok\""), error: ""}}, e=>{})
      } else return data.json().then(e => {return {ok: false, error: ""}}, e => {return {ok: false, error: e.error}})
    }
  )
}